export default "__VITE_ASSET__pl9frhbR__"